import * as THREE from 'three'
import React, { useMemo } from 'react'
import { extrudeSettings } from '../../../../../../../utils/Functions';

const WindowModel = ({ width, height, trimWidth, trimColor, doorColor, glassTexture }) => {

    const trimModel = useMemo(() => {        
        const model = new THREE.Shape();        
        model.moveTo((width / 2 - trimWidth - width / 6 + 0.04), (height / 2 - height / 4.5 - 0.04));
        model.bezierCurveTo(
            (width / 4 + 0.08), (height / 2 - height / 20 + 0.07),
            -(width / 4 + 0.08), (height / 2 - height / 20 + 0.07),
            -(width / 2 - trimWidth - width / 6 + 0.04), (height / 2 - height / 4.5 - 0.04))
        model.closePath();

        const hole = new THREE.Path();     
        hole.moveTo(-(width / 2 - trimWidth - width / 6 + 0.035), (height / 2 - height / 4.5 - 0.035));
        hole.bezierCurveTo(
            -(width / 4 + 0.05), (height / 2 - height / 20 + 0.06),
            (width / 4 + 0.05), (height / 2 - height / 20 + 0.06),
            (width / 2 - trimWidth - width / 6 + 0.035), (height / 2 - height / 4.5 - 0.035))
        hole.closePath();

        model.holes.push(hole);

        return model
    }, [width, height, trimWidth])

    const railModel = useMemo(() => {
        let model = [];

        const railRound = new THREE.Shape();        
            const railRoundWidth = width / 4;
            const railRoundHeight = height / 4.5 - height / 20;

        railRound.moveTo(-(railRoundWidth / 2 + 0.07), (height / 2 - height / 4.5));
        railRound.bezierCurveTo(
          -(width / 10 + 0.05), (height / 2 - height / 4.5 + railRoundHeight / 2 + 0.08),
          (width / 10 + 0.05), (height / 2 - height / 4.5 + railRoundHeight / 2 + 0.08),
          (railRoundWidth / 2 + 0.07), (height / 2 - height / 4.5))
        railRound.closePath();

        const railRoundHole = new THREE.Path();
        railRoundHole.moveTo(-railRoundWidth / 2, (height / 2 - height / 4.5));
        railRoundHole.bezierCurveTo(
          -(width / 10), (height / 2 - height / 4.5 + railRoundHeight / 2),
          (width / 10), (height / 2 - height / 4.5 + railRoundHeight / 2),
          railRoundWidth / 2, (height / 2 - height / 4.5))
        railRoundHole.closePath();

        railRound.holes.push(railRoundHole);

        const railMiddle = new THREE.Shape();

        railMiddle.moveTo(-0.035, height / 2 - height / 4.5 + railRoundHeight / 2.5);
        railMiddle.lineTo(0.035, height / 2 - height / 4.5 + railRoundHeight / 2.5);
        railMiddle.lineTo(0.035, height / 2 - height / 15);
        railMiddle.lineTo(-0.035, height / 2 - height / 15);
        railMiddle.closePath();

        const railLeft = new THREE.Shape();

        railLeft.moveTo(-(width / 9 + 0.001), height / 2 - height / 4.25 + railRoundHeight / 4);
        railLeft.lineTo(-(width / 10 - 0.001), height / 2 - height / 4.25 + railRoundHeight / 4 + 0.05);
        railLeft.lineTo(-(width / 4 - 0.001), height / 2 - height / 10);
        railLeft.lineTo(-(width / 3.9 + 0.001), height / 2 - height / 10 - 0.05);
        railLeft.closePath();

        const railRight = new THREE.Shape();

        railRight.moveTo((width / 9 + 0.001), height / 2 - height / 4.25 + railRoundHeight / 4);
        railRight.lineTo((width / 10 - 0.001), height / 2 - height / 4.25 + railRoundHeight / 4 + 0.05);
        railRight.lineTo((width / 4 - 0.001), height / 2 - height / 10);
        railRight.lineTo((width / 3.9 + 0.001), height / 2 - height / 10 - 0.05);
        railRight.closePath();

        
        model.push(railRound);
        model.push(railMiddle);
        model.push(railLeft);
        model.push(railRight);

        return model;
    }, [width, height])

    const glassModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-(width / 2 - trimWidth - width / 6), (height / 2 - height / 4.5));
        model.bezierCurveTo(
            -(width / 4), (height / 2 - height / 20),
            (width / 4), (height / 2 - height / 20),
            (width / 2 - trimWidth - width / 6), (height / 2 - height / 4.5))
        model.closePath();

        return model;
    }, [width, height, trimWidth])
    
    return (
        <>
            <mesh name='trim' position={[0, 0, 0.02]}>
                <extrudeGeometry args={[trimModel, extrudeSettings(0.25, 0.03, 0.03, 0, 2)]} />
                <meshStandardMaterial  color={doorColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} />
            </mesh>
            <mesh name='glass-rail' position={[0, 0, 0.025]}>
                <extrudeGeometry args={[railModel, extrudeSettings(0.25)]} />
                <meshStandardMaterial color={doorColor} side={THREE.DoubleSide}  />
            </mesh>
            <mesh name='glass' position={[0, 0, 0.05]}>
                <extrudeGeometry args={[glassModel, extrudeSettings(0.2)]} />
                <meshPhongMaterial envMap={glassTexture} side={THREE.DoubleSide} reflectivity={1}  />
            </mesh>
        </>
    )
}

export default WindowModel